// removed by extract-text-webpack-plugin
module.exports = {"dialog":"Modal__dialog___2iYqo","closeButton":"Modal__closeButton___13rjR","root":"Modal__root___3ncWM","fadeIn":"Modal__fadeIn___379-T","slideIn":"Modal__slideIn___zPXeU","header":"Modal__header___3Mpir","body":"Modal__body___2ilKb","footer":"Modal__footer___20Zc7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal.scss
// module id = 173
// module chunks = 1